import { Spin } from 'antd';

const LoaderLogo = () => {
	return <Spin spinning={true} fullscreen />;
};

export default LoaderLogo;
